import { HttpErrorResponse } from '@angular/common/http';
import { Action, createReducer, on } from '@ngrx/store';

import {
  PostComeroundProjectFailure,
  PostComeroundProjectRequest,
  PostComeroundProjectReset,
  PostComeroundProjectSuccess,
} from './actions';
import { HomeProject } from '@models/swagger';

export const featureKey = 'postComeroundProject';

export interface State {
  data: HomeProject | null;
  error: HttpErrorResponse | null;
  loading: boolean;
}

export const initialState: State = {
  data: null,
  error: null,
  loading: null,
};

export function reducer(state: State | undefined, action: Action) {
  return createReducer(
    initialState,
    on(PostComeroundProjectFailure, (state, { error }) => ({ ...state, data: null, error, loading: false })),
    on(PostComeroundProjectRequest, state => ({ ...state, error: null, loading: true })),
    on(PostComeroundProjectSuccess, (state, { data }) => ({ ...state, data, error: null, loading: false })),
    on(PostComeroundProjectReset, state => ({ ...state, data: null, error: null, loading: false }))
  )(state, action);
}
